export const TRADE_TABS = [
  'markets',
  'accounts',
  'orders',
  'positions',
  'watchlist',
  'bots',
] as const;
export type TradeTab = (typeof TRADE_TABS)[number];

const LEGACY_TRADE_TAB_ALIASES: Record<string, TradeTab> = {
  investing: 'accounts',
};

export function isTradeTab(value: string): value is TradeTab {
  return (TRADE_TABS as readonly string[]).includes(value);
}

export function parseTradeTab(value: string | undefined): TradeTab {
  if (value && LEGACY_TRADE_TAB_ALIASES[value]) return LEGACY_TRADE_TAB_ALIASES[value];
  if (value && isTradeTab(value)) return value;
  return 'positions';
}
